import { defineAsyncComponent } from 'vue';
import { mountApp, app } from '@/js/app-entries/app-entry-points/edu-ai-global';

if (document.querySelector('converter')) {
    const Converter = defineAsyncComponent(() => import('@/js/cryptocurrencies/converter/Converter.vue'));
    app.component('Converter', Converter);
}

if (document.querySelector('#currency-converter')) {
    const CurrencyConverter = defineAsyncComponent(() => import('@/js/cryptocurrencies/converter/currency-converter/currencyConverter.vue'));
    app.component('CurrencyConverter', CurrencyConverter);
}

if (document.querySelector('converter-comparison-widget')) {
    const ConverterComparisonWidget = defineAsyncComponent(() => import('@/js/cryptocurrencies/converter/converter-compare/ConverterComparisonWidget.vue'));
    app.component('ConverterComparisonWidget', ConverterComparisonWidget);
}

mountApp();
